//// Loading animation
// const isLoaded = sessionStorage.getItem('loaded');
// const loading = document.getElementById('loading');
// const wrapper = document.getElementById('wrapper')

// if (isLoaded !== 'true') {
//   document.addEventListener('DOMContentLoaded', function() {
//     if (loading) {
//       loading.classList.add('is-loading');
//     }
//     setTimeout(() => {
//       if (loading) {
//         loading.classList.add('is-loaded');
//       }
//       wrapper.classList.add('is-loaded');
//       sessionStorage.setItem('loaded', 'true');
//     }, 1500);
//   });
// } else {
//   document.addEventListener('DOMContentLoaded', function() {
//     if (loading) {
//       loading.classList.add('is-hidden');
//     }
//     wrapper.classList.add('is-loaded');
//   });
// }

let switchByWidth = "pc";
let onStartSlider;
if (document.body.classList.contains("home")) {
  const playerController = document.querySelector(".fn-player-controller");

  function onSwitchByWidth() {
    if (window.matchMedia("(max-width: 767px)").matches) {
      switchByWidth = "sp";
    } else if (window.matchMedia("(min-width:768px)").matches) {
      switchByWidth = "pc";
    }
  }

  // video list (able to set an array)
  const videoList = [
    {
      pc: "lgNywMdqHiY",
      sp: "thxVxnWn000",
    },
  ];
  // select random youtube link
  // const selectnum = Math.floor(Math.random() * videoList.length);
  const selectnum = 0;

  // 2. This code loads the IFrame Player API code asynchronously.
  const tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  const firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // 3. This function creates an <iframe> (and YouTube player)
  //    after the API code downloads.
  let player;
  window.onYouTubeIframeAPIReady = function () {
    onSwitchByWidth();
    player = new YT.Player("player", {
      videoId: videoList[selectnum][switchByWidth],
      playerVars: {
        // playlist: videoList[selectnum],
        // loop: 1,
        playsinline: 1,
        controls: 0,
        autoplay: 1,
        showinfo: 0,
        rel: 0,
        autohide: 1,
        start: 0,
        enablejsapi: 1, //JavaScript API 有効
        iv_load_policy: 3, //動画アノテーションを表示しない
        disablekb: 1, //キーボード操作OFF
        wmode: "transparent",
        suggestedQuality: "hd1080",
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  };

  // 4. The API will call this function when the video player is ready.
  function onPlayerReady(event) {
    event.target.mute(); // 音声を消す
    event.target.playVideo(); // 動画再生
    document.getElementById("player").classList.add("is-playing");
    playerController.classList.add("is-playing");
  }

  // 5. The API calls this function when the player's state changes.
  //    The function indicates that when playing a video (state=1),
  //    the player should play for six seconds and then stop.
  let done = false;
  function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING && !done) {
      setTimeout(stopVideo, Number(event.target.getDuration()) * 1000 - 4000);
      done = true;
    }
  }

  if (playerController) {
    playerController.addEventListener("click", (e) => {
      if (e.currentTarget.classList.contains("is-mute")) {
        e.currentTarget.classList.remove("is-mute");
        player.unMute();
      } else {
        e.currentTarget.classList.add("is-mute");
        player.mute();
      }
    });
  }

  function stopVideo() {
    onStartSlider();
    playerController.classList.remove("is-playing");
    document.getElementById("player").classList.remove("is-playing");
    setTimeout(() => {
      player.stopVideo();
    }, 3000);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  jQuery(function ($) {
    // iphoneだけ、16px以下でズームされるのをされないように
    const ua = navigator.userAgent.toLowerCase();
    const isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        const viewportContent = viewport.getAttribute("content");
        viewport.setAttribute(
          "content",
          viewportContent + ", user-scalable=no"
        );
      }
    }

    inView(".fn-animate").on("enter", function (el) {
      var animateProperty = el.dataset.animate;
      el.classList.add(animateProperty);
    });

    inView(".fn-image-lazy").on("enter", function (el) {
      onChangeLazy(el);
    });

    const onChangeEachLazy = (array, attr, dataset) => {
      array.each((i, img) => {
        const $img = $(img);
        if (!$img.hasClass("loaded")) {
          $img.addClass("loaded");
          $img.attr(attr, $img.data(dataset));
        }
      });
    };

    const onChangeLazy = (el) => {
      const src = $(el).find("[data-lazy]");
      const srcset = $(el).find("[data-lazy-srcset]");

      if (src && src.length > 0) {
        onChangeEachLazy(src, "src", "lazy");
      }
      if (srcset && srcset.length > 0) {
        onChangeEachLazy(srcset, "srcset", "lazy-srcset");
      }
    };

    // slider
    onStartSlider = () => {
      $(".fn-slider-top")
        .on("init reinit", function (event, slick) {
          onChangeLazy(slick.$slides.get(slick.currentSlide));
          onChangeLazy(slick.$slides.get(slick.currentSlide + 1));
          slick.$slides.get(slick.currentSlide).classList.add("active");
        })
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          onChangeLazy(slick.$slides.get(nextSlide));
          slick.$slides.get(nextSlide).classList.add("active");

          if (slick.$slides.get(currentSlide).classList.contains("active")) {
            window.setTimeout(() => {
              slick.$slides.get(currentSlide).classList.remove("active");
            }, 3000);
          }
        })
        .slick({
          autoplay: true,
          autoplaySpeed: 2000,
          speed: 3000,
          slidesToScroll: 1,
          arrows: false,
          lazyLoad: false,
          fade: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: false,
        });
    };

    $(".fn-slider-default")
      .on("init reinit", function (event, slick) {
        onChangeLazy(slick.$slides.get(slick.currentSlide));
        onChangeLazy(slick.$slides.get(slick.currentSlide + 1));
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        onChangeLazy(slick.$slides.get(nextSlide));
      })
      .slick({
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 3000,
        slidesToScroll: 1,
        arrows: false,
        lazyLoad: false,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
      });

    const $pagination = $(".fn-pagination");
    const $sliderArticle = $(".fn-slider-article");
    const hasDots = $sliderArticle.hasClass("has-dots");
    const isAutoplay = $sliderArticle.hasClass("is-autoplay");
    const isMoveArrow = $sliderArticle.hasClass("is-move-arrow");
    $sliderArticle
      .on("init reinit", function (event, slick) {
        onChangeLazy(slick.$slides.get(slick.currentSlide));
        onChangeLazy(slick.$slides.get(slick.currentSlide + 1));
        if (hasDots) {
          $pagination.prepend(slick.$dots);
        }
        if (isMoveArrow) {
          $pagination.prepend(slick.$nextArrow);
          $pagination.find(".prev").prepend(slick.$prevArrow);
          $pagination.find(".next").prepend(slick.$nextArrow);
        }
        $pagination
          .find(".total")
          .text(("00" + slick.$slides.length).slice(-2));
        $pagination
          .find(".current")
          .text(("00" + (slick.currentSlide + 1)).slice(-2));
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        $pagination.find(".current").text(("00" + (nextSlide + 1)).slice(-2));
        onChangeLazy(slick.$slides.get(nextSlide));
      })
      .slick({
        autoplay: isAutoplay,
        autoplaySpeed: 3000,
        speed: 3000,
        slidesToScroll: 1,
        arrows: true,
        dots: hasDots,
        lazyLoad: false,
        // customPaging: (event) => {
        //   console.log(event);
        //   return event;
        // },
      });

    $(".fn-slider-carousel")
      .on("init reinit", function (event, slick) {
        // $(slick.$slides).each((i, img) => {
        //   onChangeLazy(img);
        // });
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        // $(slick.$slides).each((i, img) => {
        //   onChangeLazy(img);
        // });
      })
      .slick({
        arrows: false,
        variableWidth: true,
        lazyLoad: "progressive",
        draggable: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              centerMode: false,
            },
          },
        ],
      });

    $(".fn-slider-number")
      .on("init reinit", function (event, slick) {
        // $(slick.$slides).each((i, img) => {
        //   onChangeLazy(img);
        // });
      })
      .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        // $(slick.$slides).each((i, img) => {
        //   onChangeLazy(img);
        // });
      })
      .slick({
        infinite: false,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        draggable: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              variableWidth: true,
              arrows: false,
            },
          },
        ],
      });

    // no body scroll
    function bodyScrollPrevent(flag) {
      let scrollPosition;
      const body = document.getElementsByTagName("body")[0];
      const ua = window.navigator.userAgent.toLowerCase();
      const isiOS =
        ua.indexOf("iphone") > -1 ||
        ua.indexOf("ipad") > -1 ||
        (ua.indexOf("macintosh") > -1 && "ontouchend" in document);
      const scrollBarWidth = window.innerWidth - document.body.clientWidth;
      if (flag) {
        body.style.paddingRight = scrollBarWidth + "px";
        if (isiOS) {
          scrollPosition = -window.pageYOffset;
          body.style.position = "fixed";
          body.style.width = "100%";
          body.style.top = scrollPosition + "px";
        } else {
          body.style.overflow = "hidden";
        }
      } else if (!flag) {
        body.style.paddingRight = "";
        if (isiOS) {
          scrollPosition = parseInt(body.style.top.replace(/[^0-9]/g, ""));
          body.style.position = "";
          body.style.width = "";
          body.style.top = "";
          window.scrollTo(0, scrollPosition);
        } else {
          body.style.overflow = "";
        }
      }
    }

    // header menu
    const menuButton = $(".fn-menu-button");
    const menuCloseLink = $(".fn-menu-close-link");
    const headerMenu = $(".fn-header-menu");

    const toggleActive = (button, target) => {
      if (button.hasClass("is-active")) {
        target.addClass("is-active");
        bodyScrollPrevent(true);
      } else {
        target.removeClass("is-active");
        bodyScrollPrevent(false);
      }
    };

    if (menuButton.length > 0 && headerMenu.length > 0) {
      toggleActive(menuButton, headerMenu);
      menuButton.on("click", (e) => {
        e.preventDefault();
        const button = $(e.currentTarget);
        button.toggleClass("is-active");
        toggleActive(button, headerMenu);
      });

      menuCloseLink.on("click", (e) => {
        menuButton.toggleClass("is-active");
        toggleActive(menuButton, headerMenu);
      });
    }

    // accordion
    const accordionBtn = document.querySelectorAll(".fn-accordion-btn");
    if (accordionBtn.length > 0) {
      const checkHasClass = (btn) => {
        const container = btn.parents(".fn-accordion");
        const content = btn.next(".fn-accordion-content");

        if (container.hasClass("is-active")) {
          content.show();
        } else {
          content.hide();
        }
      };
      const onClickAccordion = (btn) => {
        btn.on("click", (e) => {
          e.preventDefault();
          const list = btn.closest(".fn-accordion-list");
          const container = btn.closest(".fn-accordion");
          const content = container.children(".fn-accordion-content");
          btn.toggleClass("is-active");

          if (container.hasClass("is-active")) {
            container.removeClass("is-active");
            content.slideUp(100);
          } else {
            if (list) {
              const activedContainer = list.find(".fn-accordion");
              if (activedContainer.hasClass("is-active")) {
                activedContainer.removeClass("is-active");
                activedContainer.find(".fn-accordion-content").slideUp(100);
              }
            }

            container.addClass("is-active");
            content.slideDown(100);
            if (content.find(".fn-slider-number")) {
              $(".fn-slider-number").slick("setPosition");
            }
          }
        });
      };
      for (let i = 0; i < accordionBtn.length; i++) {
        const btn = $(accordionBtn[i]);
        checkHasClass(btn);
        onClickAccordion(btn);
      }
    }

    // modal
    if (document.querySelector(".fn-gallery")) {
      $(".fn-gallery").modaal({
        type: "image",
      });
    }
  });

  // select subject-to from params on contact form
  const selectContactItems = document.querySelector(
    'select[name="subject-to"]'
  );
  if (selectContactItems) {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has("subject_to")) {
      const selectedOption = searchParams.get("subject_to");
      for (let i = 0; i < selectContactItems.options.length; ++i) {
        if (selectContactItems.options[i].value === selectedOption) {
          selectContactItems.options[i].selected = true;
        }
      }
    }
  }

  // For FAQ
  const hash = window.location.hash; // URLのハッシュ部分を取得
  if (hash) {
    try {
      // "#" を取り除いてデコード
      const decodedId = decodeURIComponent(hash.slice(1)); // "#" を除去

      // IDを基に要素を取得
      const targetElement = document.getElementById(decodedId);

      console.log("Target Element:", targetElement); // 要素が存在するか確認

      if (targetElement) {
        // スクロール
        targetElement.scrollIntoView({ behavior: "smooth" });

        // 要素内に .fn-accordion-btn がある場合、クリック
        const accordionBtn = targetElement.querySelector(".fn-accordion-btn");
        if (accordionBtn) {
          accordionBtn.click();
        }
      } else {
        console.warn("対象要素が見つかりません:", decodedId);
      }
    } catch (error) {
      console.error("ハッシュ処理中にエラーが発生しました:", error);
    }
  }
});
